import type { FC } from 'react';

import TextUnderCard from 'components/TextUnderCard';
import { RouteTypes } from 'RouteTypes';

import { BundleCardWrapper, BundleLabel } from './styled';
import type { CollectedCardProps } from './types';

const CollectedCard: FC<CollectedCardProps> = ({
  card,
  Component,
  textForCard,
  isCollectedCollection,
  collectionId,
  username,
  dataTestId,
  bundleAmount,
  onClick,
}) => {
  const cardUrl = RouteTypes.Card
    .replace(':username', username || '')
    .replace(':collectionId', collectionId || '')
    .replace(':cardId', card.cardId || '')
    .replace(':edition?', card.edition || '');

  const isBundle = Number(bundleAmount) > 1;
  return (
    <div data-test-id={dataTestId}>
      <BundleCardWrapper $bundleLength={bundleAmount} onClick={isBundle ? onClick : undefined}>
        <Component
          card={card}
          cardUrl={isBundle ? '' : cardUrl}
          isCollectedCollection={isCollectedCollection}
          collectionId={collectionId}
          listing={isBundle || !isCollectedCollection ? textForCard.listing : false}
          listingsCount={textForCard.listingsCount}
          price={isCollectedCollection ? card.price : textForCard.price}
        />
        {isBundle && (
          <BundleLabel>
            {bundleAmount}
            {' '}
            CARDS
          </BundleLabel>
        )}
      </BundleCardWrapper>
      {
        isCollectedCollection ? (
          <TextUnderCard
            forSale={card.forSale}
            price={card.price}
            isCollectedCollection
            isStaked={card.staked}
            listing={isBundle ? textForCard.listing : false}
          />
        ) : (
          <TextUnderCard
            listing={textForCard.listing}
            price={textForCard.price}
            listingsCount={textForCard.listingsCount}
          />
        )
      }
    </div>
  );
};

export default CollectedCard;
